<template>
    <div>
        <p class="title">申请人信息</p>
        <van-cell-group>
            <van-field required  label="社会福利机构名称" v-model="baseInfo.shfljgmc"
                       input-align="right"/>
            <van-field required  label="社会福利机构地址" v-model="baseInfo.shfljgdz"
                       input-align="right"/>
            <van-field required readonly label="姓名" v-model="baseInfo.xm" readonly
                       input-align="right"/>
            <van-field required readonly clickable label="性别" v-model="baseInfo.xbmc" placeholder="请选择"
                       @click="showPickerSex = true" input-align="right" is-link/>
            <van-popup v-model="showPickerSex" position="bottom">
                <van-picker show-toolbar :columns="sexList" value-key="name" @cancel="showPickerSex = false"
                            @confirm="onConfirmSex"/>
            </van-popup>
            <van-field required readonly clickable label="出生日期" v-model="baseInfo.csrq" placeholder="请选择"
                       @click="showPickerBirthDate = true" input-align="right" is-link/>
            <van-popup v-model="showPickerBirthDate" position="bottom">
                <van-datetime-picker v-model="currentDate" type="date" :max-date="maxDate" :min-date="minDate"
                                     @cancel="showPickerBirthDate = false" @confirm="onConfirmBirthdayDate"/>
            </van-popup>
            <van-field required v-model="baseInfo.gmsfhm" clearable readonly label="公民身份证号" placeholder="请输入身份证号"
                       input-align="right"/>
            <van-field required v-model="baseInfo.lxdh" clearable  label="联系电话" placeholder="联系电话"
                       input-align="right"/>
        </van-cell-group>



        <!--申请信息-------------------------------------------------------------------->
        <p class="title">申请信息</p>
        <van-cell-group>
            <van-field required  label="拟注销人姓名" v-model="body.nzxr_xm"
                       input-align="right"/>
            <van-field required readonly clickable label="性别" v-model="body.xbmc" placeholder="请选择"
                       @click="showPickerZxrSex = true" input-align="right" is-link/>
            <van-popup v-model="showPickerZxrSex" position="bottom">
                <van-picker show-toolbar :columns="sexList" value-key="name" @cancel="showPickerZxrSex = false"
                            @confirm="onConfirmZxrSex"/>
            </van-popup>
            <van-field required readonly clickable label="出生日期" v-model="body.nzxr_csrq" placeholder="请选择"
                       @click="showPickerZxrBirthDate = true" input-align="right" is-link/>
            <van-popup v-model="showPickerZxrBirthDate" position="bottom">
                <van-datetime-picker v-model="currentDate" type="date" :max-date="maxDate" :min-date="minDate"
                                     @cancel="showPickerZxrBirthDate = false" @confirm="onConfirmZxrBirthdayDate"/>
            </van-popup>
            <van-field required v-model="body.nzxr_gmsfhm" clearable label="公民身份证号" placeholder="请输入公民身份证号"
                       input-align="right"/>
            <van-field required readonly clickable label="民族" v-model="body.mz" placeholder="请选择"
                       @click="showPickerMz = true" input-align="right" is-link/>
            <van-popup v-model="showPickerMz" position="bottom">
                <van-picker show-toolbar :columns="mzList" value-key="title" @cancel="showPickerMz = false"
                            @confirm="onConfirmMz"/>
            </van-popup>


            <!--籍贯-------------------------------------------------------------------->
            <van-field v-model="chinaAddr.root" label="籍贯:" placeholder="请选择国家" is-link required readonly
                       input-align="right"
                       />

            <van-field v-model="chinaAddr.jgPro" placeholder="请选择省份" is-link required readonly
                       input-align="right"
                       @click="showPickerJGProvince = true"/>
            <van-popup v-model="showPickerJGProvince" position="bottom">
                <van-picker :columns="provinceJGList" show-toolbar value-key="title"
                            @cancel="showPickerLHProvince = false"
                            @confirm="onConfirmJGProvince"/>
            </van-popup>
            <van-field v-model="chinaAddr.jgCity" placeholder="请选择市区" is-link readonly input-align="right"
                       @click="showPickerJGCity = true" v-if="JGCityShow"/>
            <van-popup v-model="showPickerJGCity" position="bottom">
                <van-picker :columns="cityJGList" show-toolbar value-key="title" @cancel="showPickerJGCity = false"
                            @confirm="onConfirmJGCity"/>
            </van-popup>
            <van-field v-model="chinaAddr.jgArea" placeholder="请选择区县" is-link readonly input-align="right"
                       @click="showPickerJGArea = true" v-if="JGAreaShow"/>
            <van-popup v-model="showPickerJGArea" position="bottom">
                <van-picker :columns="areaJGList" show-toolbar value-key="title" @cancel="showPickerJGArea = false"
                            @confirm="onConfirmJGArea"/>
            </van-popup>
            <van-field input-align="right" type="textarea" v-model="chinaAddr.jgXxdz"
                       placeholder="请输入区划内详细地址" rows="1" autosize clearable/>


            <!--户籍地址-------------------------------------------------------------------->
            <van-field v-model="chinaAddr.hjPro" label="户籍地址:" placeholder="请选择省份" is-link required readonly
                       input-align="right"
                       @click="showPickerHJProvince = true"/>
            <van-popup v-model="showPickerHJProvince" position="bottom">
                <van-picker :columns="provinceList" show-toolbar value-key="title"
                            @cancel="showPickerHJProvince = false"
                            @confirm="onConfirmHJProvince"/>
            </van-popup>
            <van-field v-model="chinaAddr.hjCity" placeholder="请选择市区" is-link readonly input-align="right"
                       @click="showPickerHJCity = true" v-if="HJCityShow"/>
            <van-popup v-model="showPickerHJCity" position="bottom">
                <van-picker :columns="cityHJList" show-toolbar value-key="title" @cancel="showPickerHJCity = false"
                            @confirm="onConfirmHJCity"/>
            </van-popup>
            <van-field v-model="chinaAddr.hjArea" placeholder="请选择区县" is-link readonly input-align="right"
                       @click="showPickerHJArea = true" v-if="HJAreaShow"/>
            <van-popup v-model="showPickerHJArea" position="bottom">
                <van-picker :columns="areaHJList" show-toolbar value-key="title" @cancel="showPickerHJArea = false"
                            @confirm="onConfirmHJArea"/>
            </van-popup>
            <van-field input-align="right" type="textarea" v-model="chinaAddr.hjXxdz"
                       placeholder="请输入区划内详细地址" rows="1" autosize clearable/>
            <van-field input-align="right" label="户籍地派出所:" type="textarea" required v-model="body.nzxr_sspcs"
                       placeholder="请输入户籍地派出所" rows="1" autosize clearable/>
        </van-cell-group>
    </div>
</template>

<script>
  import { Button, Toast, CellGroup, Field, Dialog, Popup, Picker, DatetimePicker, RadioGroup, Radio } from 'vant'
  import { dateToString } from '@/utils/time'
  import { baseApiMap } from '@/api/base'
  import { idCardRegex, phoneRegex } from '@/utils/regex'
  import { forEachObj } from '@/utils/check'

  export default {
    components: {
      [Button.name]: Button,
      [Toast.name]: Toast,
      [CellGroup.name]: CellGroup,
      [Field.name]: Field,
      [Dialog.name]: Dialog,
      [Popup.name]: Popup,
      [Picker.name]: Picker,
      [DatetimePicker.name]: DatetimePicker,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio
    },
    props: {
      applicationInfo: {
        type: Object,
        default: () => ({})
      },
    },
    data() {
      return {
          sexList: [],//
          mzList:[],//
          china:[{"title": '中国', "val": '0'}],
          provinceJGList: [{"title": '湖北省', "val": '420000'}], // 籍贯地址省
          cityJGList: [], // 籍贯地址市
          areaJGList: [], // 籍贯地址区县
          showPickerJGProvince: false, // 是否显示地址省选择框
          JGCityShow: false, // 是否显示地址市
          JGAreaShow: false, // 是否显示地址区县
          showPickerJGCity: false, // 是否显示地址市选择框
          showPickerJGArea: false, // 是否显示地址区县选择框

          provinceList: [], // 省
          cityHJList: [], // 户籍市
          areaHJList: [], // 户籍区县
          showPickerHJProvince: false, // 是否显示户籍省选择框
          HJCityShow: false, // 是否显示户籍市
          HJAreaShow: false, // 是否显示户籍区县
          showPickerHJCity: false, // 是否显示户籍市选择框
          showPickerHJArea: false, // 是否显示户籍区县选择框

          showPickerMz:false,//是否显示民族选择框
          showPickerSex: false, // 是否显示性别选择框
          showPickerZxrSex: false, // 申请信息中显示性别选择框
          currentDate: new Date(), // 当前日期
          minDate: new Date(1900, 0, 1), // 最小日期
          maxDate: new Date(), //最大日期
          showPickerBirthDate: false, // 是否显示出生日期选择框
          showPickerZxrBirthDate: false, // 申请信息中是否显示出生日期选择框
          baseInfo: {
              shfljgmc:"",//社会福利机构名称
              shfljgdz:"",//社会福利机构地址
              xm: this.$cookie.getUser().realName,
              xbmc:"",
              xb: '',
              csrq: '',
              gmsfhm: this.$cookie.getUser().idNum.replace(/^(\d{3})\d{10}(\d+)/, '$1**********$2'),
              lxdh:this.$cookie.getUser().telephone,
          },
          chinaAddr:{
              root:"中国",
              jgPro:"",
              jgCity:"",
              jgArea:"",
              jgXxdz:"",
              hjPro:"",
              hjCity:"",
              hjArea:"",
              hjXxdz:"",
          },
          body:{
              nzxr_xm:"",//拟注销人姓名
              xbmc:"",
              nzxr_xb:"",//性别
              nzxr_csrq:"",//出生日期
              nzxr_gmsfhm:"",//身份证号\
              mz:"",//民族名称
              nzxr_mz:"",//民族
              nzxr_jg:"",//籍贯
              nzxr_hjdz:"",//户籍地址
              nzxr_sspcs:""//所属派出所
          }
      }
    },
    mounted() {
        this.getProvinceData();
        this.getSexList();
        this.getNation();
    },
    methods: {
      /**aseInfo
       * 校验数据
       */
      validApplication() {
            forEachObj(this.baseInfo); // 去掉空格
            forEachObj(this.body);
            if (!this.baseInfo.shfljgmc) {
              Toast('请输入社会福利机构名称')
              this.$emit('getApplicationBaseInfo', false)
              return
            }
           if (!this.baseInfo.shfljgdz) {
              Toast('请输入社会福利机构地址')
              this.$emit('getApplicationBaseInfo', false)
              return
           }
          if (!this.baseInfo.xm) {
              Toast('请输入申请人姓名')
              this.$emit('getApplicationBaseInfo', false)
              return
          }
          if (!this.baseInfo.xb) {
              Toast('请选择性别')
              this.$emit('getApplicationPersonInfo1', false)
              return
          }
          if (!this.baseInfo.csrq) {
              Toast('请选择出生日期')
              this.$emit('ggetApplicationBaseInfo', false)
              return
          }
          if (!this.baseInfo.gmsfhm) {
              Toast('请输入公民身份证号')
              this.$emit('getApplicationBaseInfo', false)
              return
          }
          if (!this.baseInfo.lxdh) {
              Toast('请输入联系电话')
              this.$emit('getApplicationBaseInfo', false)
              return
          }
          //校验填报申请信息
          if (!this.body.nzxr_xm) {
              Toast('请输入拟注销人姓名')
              this.$emit('getApplicationBaseInfo', false)
              return
          }
          if (!this.body.nzxr_xb) {
              Toast('请选择性别')
              this.$emit('getApplicationBaseInfo', false)
              return
          }
          if (!this.body.nzxr_csrq) {
              Toast('请选择出生日期')
              this.$emit('getApplicationBaseInfo', false)
              return
          }
          if (!this.body.nzxr_gmsfhm) {
              Toast('请输入公民身份证号')
              this.$emit('getApplicationBaseInfo', false)
              return
          }
          if (!idCardRegex(this.body.nzxr_gmsfhm)) {
              Toast('公民身份证号输入有误')
              return
          }
          if (!this.body.nzxr_mz) {
              Toast('请选择民族')
              this.$emit('getApplicationBaseInfo', false)
              return
          }
          if (!this.chinaAddr.jgArea) {
              Toast('请选择籍贯')
              this.$emit('getApplicationBaseInfo', false)
              return
          }
          if (!this.chinaAddr.hjArea) {
              Toast('请选择户籍地址')
              this.$emit('getApplicationBaseInfo', false)
              return
          }
          if (!this.body.nzxr_sspcs) {
              Toast('请输入所属派出所')
              this.$emit('getApplicationBaseInfo', false)
              return
          }
            this.applicationInfo.shfljgmc = this.baseInfo.shfljgmc,
            this.applicationInfo.shfljgdz = this.baseInfo.shfljgdz,
            this.applicationInfo.xm = this.baseInfo.xm
            this.applicationInfo.xb = this.baseInfo.xb
            this.applicationInfo.csrq = this.baseInfo.csrq
            this.applicationInfo.gmsfhm = this.$cookie.getUser().idNum
            this.applicationInfo.lxdh = this.baseInfo.lxdh
            this.applicationInfo.nzxr_xm = this.body.nzxr_xm;
            this.applicationInfo.nzxr_xb = this.body.nzxr_xb
            this.applicationInfo.nzxr_csrq = this.body.nzxr_csrq
            this.applicationInfo.nzxr_gmsfhm = this.body.nzxr_gmsfhm
            this.applicationInfo.nzxr_mz = this.body.nzxr_mz
            this.applicationInfo.nzxr_jg = this.chinaAddr.jgPro+this.chinaAddr.jgCity+this.chinaAddr.jgArea+this.chinaAddr.jgXxdz
            this.applicationInfo.nzxr_hjdz = this.chinaAddr.hjPro+this.chinaAddr.hjCity+this.chinaAddr.hjArea+this.chinaAddr.hjXxdz
            this.applicationInfo.nzxr_sspcs = this.body.nzxr_sspcs
            this.$emit('getApplicationBaseInfo', true)
            return
      },
        /**
         * 获取市
         */
        async getJGCityData(value) {
            try {
                this.cityJGList = []
                this.areaJGList = []
                const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                let arr = [];
                if (res.data.succ = true) {
                    let d = res.data.data
                    for (let i = 0; i < d.length; i++) {
                        arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                    }
                }
                this.cityJGList = arr
                if (this.cityJGList.length > 0) {
                    this.JGCityShow = true
                } else {
                    this.JGCityShow = false
                }
            } catch (error) {
                Toast('服务器运行失败');
                console.log(error);
            }
        },
        /**
         * 获取地区
         */
        async getJGAreaData(value) {
            try {
                this.areaJGList = []
                const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                let arr = [];
                if (res.data.succ = true) {
                    let d = res.data.data
                    for (let i = 0; i < d.length; i++) {
                        arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                    }
                }
                this.areaJGList = arr
                if (this.areaJGList.length > 0) {
                    this.JGAreaShow = true
                } else {
                    this.JGAreaShow = false
                }
            } catch (error) {
                Toast('服务器运行失败');
                console.log(error);
            }
        },
        /**
         * 加载性别
         */
        getSexList() {
            this.$httpUtils.getCommonUtils(`${baseApiMap.dict}/dic.hz.xblb`).then(response => {
                let arr = [];
                if (response.data.succ = true) {
                    let arrSex = response.data.data;
                    for (let i = 0; i < arrSex.length; i++) {
                        arr.push({ "name": arrSex[i].title, "key": arrSex[i].val })
                    }
                }
                this.$nextTick(() => {
                    this.sexList = arr
                })
            }).catch(err => {

            })
        },

        /**
         * 获取省
         */
        async getProvinceData() {
            try {
                const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + 0)
                let arr = [];
                if (res.data.succ = true) {
                    let d = res.data.data
                    for (let i = 0; i < d.length; i++) {
                        arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                    }
                }
                this.provinceList = arr
            } catch (error) {
                Toast('服务器运行失败')
                console.log(error);
            }
        },
        /**
         * 获取市
         */
        async getHJCityData(value) {
            try {
                this.cityHJList = []
                this.areaHJList = []
                const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                let arr = [];
                if (res.data.succ = true) {
                    let d = res.data.data
                    for (let i = 0; i < d.length; i++) {
                        arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                    }
                }
                this.cityHJList = arr
                if (this.cityHJList.length > 0) {
                    this.HJCityShow = true
                } else {
                    this.HJCityShow = false
                }
            } catch (error) {
                Toast('服务器运行失败');
                console.log(error);
            }
        },
        /**
         * 获取地区
         */
        async getHJAreaData(value) {
            try {
                this.areaHJList = []
                const res = await this.$httpUtils.getCommonUtils(baseApiMap.registeredaArea + '/' + value);
                let arr = [];
                if (res.data.succ = true) {
                    let d = res.data.data
                    for (let i = 0; i < d.length; i++) {
                        arr.push({ "title": d[i].regionname, "val": d[i].regioncode })
                    }
                }
                this.areaHJList = arr
                if (this.areaHJList.length > 0) {
                    this.HJAreaShow = true
                } else {
                    this.HJAreaShow = false
                }
            } catch (error) {
                Toast('服务器运行失败');
                console.log(error);
            }
        },
        /**
         * 选择户籍地址省
         */
        onConfirmJGProvince(value) {
            this.chinaAddr.jgPro = value.title
            this.chinaAddr.jgCity = ''
            this.chinaAddr.jgArea = ''
            this.showPickerJGProvince = false
            this.getJGCityData(value.val)
        },
        /**
         * 选择户籍地址市
         */
        onConfirmJGCity(value) {
            this.showPickerJGCity = false
            this.chinaAddr.jgCity = value.title
            this.chinaAddr.jgArea = ''
            this.getJGAreaData(value.val)
        },
        /**
         * 选择户籍区县
         */
        onConfirmJGArea(value) {
            this.showPickerJGArea = false
            this.chinaAddr.jgArea = value.title
        },

        /**
         * 选择户籍地址省
         */
        onConfirmHJProvince(value) {
            this.chinaAddr.hjPro  = value.title
            this.chinaAddr.hjCity  = ''
            this.chinaAddr.hjArea  = ''
            this.showPickerHJProvince = false
            this.getHJCityData(value.val)
        },
        /**
         * 选择户籍地址市
         */
        onConfirmHJCity(value) {
            this.showPickerHJCity = false
            this.chinaAddr.hjCity = value.title
            this.chinaAddr.hjArea = ''
            this.getHJAreaData(value.val)
        },
        /**
         * 选择户籍区县
         */
        onConfirmHJArea(value) {
            this.showPickerHJArea = false
            this.chinaAddr.hjArea = value.title
        },
        /**
         * 选择出生日期
         */
        onConfirmBirthdayDate(value) {
            this.baseInfo.csrq = dateToString(value, "yyyy-MM-dd")
            this.showPickerBirthDate = false
        },
        /**
         * 选择出生日期
         */
        onConfirmZxrBirthdayDate(value) {
            this.body.nzxr_csrq = dateToString(value, "yyyy-MM-dd")
            this.showPickerZxrBirthDate = false
        },
        /**
         * 选择性别
         */
        onConfirmSex(value) {
            this.baseInfo.xbmc = value.name
            this.baseInfo.xb = value.key
            this.showPickerSex = false
        },
        /**
         * 选择性别
         */
        onConfirmZxrSex(value) {
            this.body.xbmc = value.name
            this.body.nzxr_xb = value.key
            this.showPickerZxrSex = false
        },
        /**
         * 获取民族
         */
        getNation() {
            this.$httpUtils.getCommonUtils(`${baseApiMap.dict}/dic.hz.mzlb`).then(res => {
                if (res.data.succ = true) {
                    this.mzList = res.data.data;
                }
            }).catch(err => {

            })
        },
        /**
         * 选择民族
         * @param value
         */
        onConfirmMz(value) {
            console.log(value)
            this.showPickerMz = false
            this.body.mz = value.title
            this.body.nzxr_mz = value.val
        },
    }
  }
</script>

<style>
    .van-field__label {
        width: 100px;
    }
</style>
<style lang="less" scoped>
    .title {
        padding: 0.3rem;
        color: #808080;
    }
</style>
